export const NAME = "offers"
export const FIREBASE_PATH = "offers"
